export default __webpack_public_path__ + "static/media/sleep.838b676e.svg";